exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".well{\n    margin-bottom: 0;\n}\n.notes textarea{\n    resize: vertical;\n}\n.form-group .well.error{\n    border: 1px solid #cc5965;\n}\n.text-error{\n    color: #cc5965;\n    font-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/scheduled-callbacks/scheduled-callbacks.component.css
// module id = 1214
// module chunks = 9